var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDevicePhoneLtr = function SvgDevicePhoneLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.02 14c1.094 0 1.98.672 1.98 1.5 0 .81-.846 1.47-1.905 1.499L58.02 17H43.979C42.886 17 42 16.328 42 15.5c0-.81.846-1.47 1.905-1.499L43.98 14zM51 87a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M26.897 0h45.206C75.903 0 79 3.135 79 6.981V93.02c0 3.846-3.097 6.981-6.897 6.981H26.897c-3.8 0-6.897-3.135-6.897-6.981V6.98C20 3.135 23.097 0 26.897 0m45.206 6.026H26.897a.96.96 0 0 0-.943.955V93.02a.96.96 0 0 0 .943.955h45.206a.96.96 0 0 0 .943-.955V6.98a.96.96 0 0 0-.943-.955",
    clipRule: "evenodd"
  })));
};
export default SvgDevicePhoneLtr;